var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({class:_vm.classes,attrs:{"color":_vm.buttonType,"outlined":_vm.outlined,"href":_vm.link.url,"target":_vm.link.target,"title":_vm.link.title,"rounded":"","elevation":_vm.$attrs.elevation || '0'},on:{"click":function($event){return _vm.$emit('base-click')}}},'v-btn',{ ..._vm.$attrs, ..._vm.$props },false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }